module.exports = __webpack_public_path__ + "img/11.347389c2.jpg";